import { useEffect, useMemo, useState } from 'react'
import debounce from 'lodash.debounce'
import { TextField } from '@mui/material'

type POInstructionsFieldProps = {
  label: string
  value: string
  onChange: (next: string) => void
  helperText?: string
}

export default function POInstructionsField({
  label,
  value,
  onChange,
  helperText,
}: POInstructionsFieldProps) {
  const [internal, setInternal] = useState(value)

  useEffect(() => {
    setInternal(value)
  }, [value])

  const debouncedOnChange = useMemo(
    () => debounce((next: string) => onChange(next), 500),
    [onChange],
  )

  useEffect(() => {
    return () => {
      debouncedOnChange.flush()
    }
  }, [debouncedOnChange])

  return (
    <TextField
      fullWidth
      multiline
      minRows={4}
      label={label}
      value={internal}
      helperText={helperText}
      onChange={(e) => {
        setInternal(e.target.value)
        debouncedOnChange(e.target.value)
      }}
      slotProps={{ inputLabel: { shrink: true } }}
    />
  )
}
